module.exports = __webpack_public_path__ + "static/media/gnome_offer.ee14af2d.svg";